import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SapiService } from '../../../services/sapi.service';
import { TranslateService } from '@ngx-translate/core';
import { Mediaclip } from 'app/interfaces/mediaclip';


@Component({
	selector: 'playlist-details-rss',
	templateUrl: './playlist-details-rss.component.html',
	styleUrls: ['./playlist-details-rss.component.scss']
})

export class PlaylistDetailsRssComponent implements OnInit, OnDestroy {
	@Input() playlist: any;
	@Input() form: NgForm;

	languageOptions: any[] = [];
	iTunesCategories: any[] = [
		{ value: 'Arts', label: 'Arts' },
		{ value: 'Business', label: 'Business' },
		{ value: 'Comedy', label: 'Comedy' },
		{ value: 'Education', label: 'Education' },
		{ value: 'Fiction', label: 'Fiction' },
		{ value: 'Games & Hobbies', label: 'Games & Hobbies' },
		{ value: 'Government', label: 'Government' },
		{ value: 'Health & Fitness', label: 'Health & Fitness' },
		{ value: 'History', label: 'History' },
		{ value: 'Kids & Family', label: 'Kids & Family' },
		{ value: 'Leisure', label: 'Leisure' },
		{ value: 'Music', label: 'Music' },
		{ value: 'News', label: 'News' },
		{ value: 'Religion & Spirituality', label: 'Religion & Spirituality' },
		{ value: 'Science', label: 'Science' },
		{ value: 'Society & Culture', label: 'Society & Culture' },
		{ value: 'Sports', label: 'Sports' },
		{ value: 'Technology', label: 'Technology' },
		{ value: 'True Crime', label: 'True Crime' },
		{ value: 'TV & Film', label: 'TV & Film' }
	];

	artworkFilterSet = [{
		filters: [{
			type: 'mediaclip',
			field: 'mediatype',
			operator: 'is',
			value: 'image'
		}]
	}];

	artworkToBigForItunes: boolean;
	reCheck: number;

	constructor(
		private sapiService: SapiService,
		private translate: TranslateService) {

		this.sapiService.getUrl('/language').subscribe((languageData: any) => {
			if (languageData && languageData.items && languageData.items.length) {
				const languages = languageData.items;
				if (languageData.items) {
					this.languageOptions = languages.map((language: any) => ({
						value: language.isocode,
						label: this.translate.instant('LANGUAGE_' + language.isocode.toUpperCase())
					}));
				}
			}
		});

	}

	ngOnInit() {
		this.artworkToBigForItunes = false;
		this.reCheck = 0;
	}

	ngOnDestroy() {
	}

	changedEntityId(entityId: string) {
		this.form.form.markAsDirty();

		// set to false and check if it must be true after
		this.artworkToBigForItunes = false;
		if (entityId) {
			// may re-check again if result misses width and height (happens after upload -> probing for techinfo is async in BE)
			this.reCheck = 0;
			this.checkWidthAndHeight(entityId);
		}
	}

	private checkWidthAndHeight(entityId: string) {
		this.sapiService.get('commonclip', entityId).subscribe((clip: Mediaclip) => {
			if (clip.width && clip.height) {
				if (!(clip.width > 1400 && clip.width < 3000) || !(clip.height > 1400 && clip.height < 3000)) {
					this.artworkToBigForItunes = true;
				}
			} else {
				// re-check only if clip was created today (was a new upload, otherwise there would be a width and height). Only check 5 times max.
				if (this.isToday(new Date(clip.createddate)) && this.reCheck < 5) {
					setTimeout(() => {
						this.checkWidthAndHeight(entityId);
						this.reCheck++;
					}, 1000);
				}
			}
		});
	}

	private isToday(someDate: Date) {
		const today = new Date();
		return someDate.getDate() === today.getDate() &&
			someDate.getMonth() === today.getMonth() &&
			someDate.getFullYear() === today.getFullYear();
	}
}
